import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import HomePage from "./Pages/HomePage";
import ListPage from "./Pages/ListPage";
import LoginPage from "./Pages/LoginPage.jsx";
import RegisterPage from "./Pages/RegisterPage.jsx";
import RegisterValidatorPage from "./Pages/RegisterValidatorPage.jsx";
import IndexingPage from "./Pages/IndexingPage.jsx";
// import Header from './helper/Header.jsx';
import Footer from './helper/Footer.jsx';
import AddNewActPage from './Pages/AddNewActPage.jsx'
import UpdateActPage from './Pages/UpdateActPage.jsx'
import LanguageListingPage from "./Pages/LanguageListingPage";
import LanguageListTwo from "./Pages/LanguageListTwo";
import LanguageListThree from "./Pages/LanguageListThree";
import LanguageListFour from "./Pages/LanguageListFour";
import RequestList from "./Pages/RequestList.jsx";
import UserRequestList from "./Pages/UserRequestList.jsx";

const WebRoutes = () => {
    return (
        <Router>
            {/* <Header/> */}
            <Routes>
                <Route path="/lawdictionary/list" element={<ListPage />} />
                <Route path="/lawdictionary/" element={<HomePage />} />
                <Route path="/lawdictionary/login" element={<LoginPage />} />
                <Route path="/lawdictionary/register" element={<RegisterPage />} />
                <Route path="/lawdictionary/register-validator" element={<RegisterValidatorPage />} />
                <Route path="/lawdictionary/home" element={<IndexingPage />} />
                <Route path="/lawdictionary/add-new" element={<AddNewActPage />} />
                <Route path="/lawdictionary/list/update" element={<UpdateActPage />} />
                <Route path="/lawdictionary/request-list" element={<RequestList />} />
                <Route path="/lawdictionary/user-request-list" element={<UserRequestList />} />
                <Route path="LanguageListingPage" element={<LanguageListingPage />} />
                <Route path="LanguageListTwo" element={<LanguageListTwo />} />
                <Route path="LanguageListThree" element={<LanguageListThree />} />
                <Route path="LanguageListFour" element={<LanguageListFour />} />
            </Routes>
            <Footer/>
        </Router>
    );
};

export { WebRoutes };
